import React, { useEffect, useRef, useState } from 'react'
import SwitchButtonStyle from './css/SwitchButtonStyle'

function SwitchButton(props) {
  const small = props.small
  const {id, setSwitch, on} = props
  const btnLeftRef = useRef(null)
  const btnRightRef = useRef(null)
  const switchRef = useRef(null)
  const [btn, setBtn] = useState(on)

  const onClick = (e) => {
    setBtn(!btn)
    setSwitch(id, !btn)
  }

  useEffect(() => { setBtn(on) }, [on])

  useEffect(() => {
    btnRightRef.current.classList.add('on')
    if (small) {
      switchRef.current.classList.add('small')
      switchRef.current.classList.add('small')
    }
    
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (btn) { // ON
      btnRightRef.current.classList.add('on')
      btnLeftRef.current.classList.remove('on')
      switchRef.current.classList.remove('off')
    } else {  // OFF
      btnLeftRef.current.classList.add('on')
      btnRightRef.current.classList.remove('on')
      switchRef.current.classList.add('off')
    }
  }, [btn])

  return (
    <React.Fragment>
      <div className='switch-button-wrapper'>
        <div className='switch-status'>{(btn) ? 'ON' : 'OFF'}</div>
        <div ref={switchRef} className='switch-button-container'>
          <button
            ref={btnLeftRef}
            id='switch-button-left'
            onClick={onClick}
            className='circle-button left'>
          </button>
          <button
            ref={btnRightRef}
            id='switch-button-right'
            onClick={onClick}
            className='circle-button right'>
          </button>
        </div>
      </div>
      <SwitchButtonStyle />
    </React.Fragment>
  )
}

export default React.memo(SwitchButton)
